export const manifest = {
  screens: {
    scr_9mm5mj: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_kea84e: { name: "Services Section", route: "/#services", position: {"x":160,"y":2200} },
    scr_7gl4rh: { name: "About - Sanctuary", route: "/#about", state: {"aboutTab":0}, position: {"x":160,"y":4180} },
    scr_bipkey: { name: "About - Approach", route: "/#about", state: {"aboutTab":1}, position: {"x":1560,"y":4180} },
    scr_bswy4b: { name: "About - Offerings", route: "/#about", state: {"aboutTab":2}, position: {"x":2960,"y":4180} },
    scr_wqbc34: { name: "About - Partnership", route: "/#about", state: {"aboutTab":3}, position: {"x":4360,"y":4180} },
    scr_ec8th0: { name: "Team", route: "/#team", position: {"x":160,"y":6160} },
    scr_2g0ztk: { name: "About Us Page", route: "/about", position: {"x":5760,"y":4180} },
    scr_wtrtkb: { name: "All Services Page", route: "/services", position: {"x":1560,"y":2200} },
    scr_m9ldgu: { name: "Contact Us Page", route: "/contact", position: {"x":160,"y":8140} },
    scr_g1y8o8: { name: "Blog Page", route: "/blog", position: {"x":160,"y":10120} },
    scr_kx067i: { name: "Blog Details Page", route: "/blog/1", position: {"x":1560,"y":10120} },
    scr_wkqxp1: { name: "Service Detail - Individualized Care", route: "/services/individualized-care", position: {"x":2960,"y":2200} },
    scr_xoiuef: { name: "Service Detail - Respite Care", route: "/services/respite-care", position: {"x":4360,"y":2200} },
    scr_38ft5y: { name: "Service Detail - Electronics & WiFi", route: "/services/electronics-and-wifi", position: {"x":5760,"y":2200} },
  },
  sections: {
    sec_vo9lqq: { name: "Homepage", x: 0, y: 0, width: 1520, height: 1180 },
    sec_9ku02y: { name: "Services", x: 0, y: 1980, width: 7120, height: 1180 },
    sec_t78v6t: { name: "About flow", x: 0, y: 3960, width: 7120, height: 1180 },
    sec_ew76di: { name: "Team", x: 0, y: 5940, width: 1520, height: 1180 },
    sec_tsv24f: { name: "Contact", x: 0, y: 7920, width: 1520, height: 1180 },
    sec_937jfn: { name: "Blog", x: 0, y: 9900, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_vo9lqq", children: [
      { kind: "screen", id: "scr_9mm5mj" },
    ] },
    { kind: "section", id: "sec_9ku02y", children: [
      { kind: "screen", id: "scr_kea84e" },
      { kind: "screen", id: "scr_wtrtkb" },
      { kind: "screen", id: "scr_wkqxp1" },
      { kind: "screen", id: "scr_xoiuef" },
      { kind: "screen", id: "scr_38ft5y" },
    ] },
    { kind: "section", id: "sec_t78v6t", children: [
      { kind: "screen", id: "scr_7gl4rh" },
      { kind: "screen", id: "scr_bipkey" },
      { kind: "screen", id: "scr_bswy4b" },
      { kind: "screen", id: "scr_wqbc34" },
      { kind: "screen", id: "scr_2g0ztk" },
    ] },
    { kind: "section", id: "sec_ew76di", children: [
      { kind: "screen", id: "scr_ec8th0" },
    ] },
    { kind: "section", id: "sec_tsv24f", children: [
      { kind: "screen", id: "scr_m9ldgu" },
    ] },
    { kind: "section", id: "sec_937jfn", children: [
      { kind: "screen", id: "scr_g1y8o8" },
      { kind: "screen", id: "scr_kx067i" },
    ] },
  ],
}
